export default __webpack_public_path__ + "static/media/delighted.2c7cba1b.png";